/* eslint-disable eslint-comments/no-restricted-disable */
import type { EntryPoint, EntryPointComponent } from 'react-relay';

import { JSResourceForInteraction } from '@atlassian/react-async';
import { createEntryPoint } from '@atlassian/react-entrypoint';
import type { PlanIncrementEntryPointEntrypointProps } from './PlanIncrementEntryPoint.entrypoint.types.tsx';

type PlanIncrementEntryPointComponent = EntryPointComponent<
	{},
	{},
	PlanIncrementEntryPointEntrypointProps,
	{}
>;

export const planIncrementEntryPoint: EntryPoint<PlanIncrementEntryPointComponent, {}> =
	createEntryPoint({
		root: JSResourceForInteraction<PlanIncrementEntryPointComponent>(
			/* webpackChunkName: "async-plan-increment-entrypoint" */ './PlanIncrementPlanIncrement.tsx',
		),
		getPreloadProps: () => ({}),
	});
